export default "__VITE_ASSET__581e75b5__"